import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { PublicSharedModule } from '../../../public/shared/modules/public-shared.module';
import { HowDoesWorkPage } from './how-does-work.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PublicSharedModule,
    TranslateModule,
  ],
  declarations: [
    HowDoesWorkPage
  ]
})
export class HowDoesWorkPageModule {}
